import React, { useState, useEffect, useRef, Component } from "react";
import { connect } from "react-redux";
import { history } from "../../../history/history";

import SideBar from "../common/sideBar";

import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Select from "react-select";
import draftToHtml from "draftjs-to-html";
import { EditorState, convertToRaw } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "draft-js-buttons";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import "draft-js/dist/Draft.css";
const staticToolBarPlugin = createToolbarPlugin();
const ToolbarStatic = staticToolBarPlugin.Toolbar;
class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener("click", this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((
          Button,
          i // eslint-disable-next-line
        ) => (
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

const Notification = (props) => {
  //Set initial state
  const [sentby, setsentby] = useState("email");
  const includeExpired = useRef(undefined);
  const [selectedUsers, setselectedUsers] = useState([]);
  const [audioBrief, setAudioBrief] = useState(EditorState.createEmpty());
  const [editor, setEditor] = useState("");
  const [subject, setsubject] = useState("");
  const [message, setmessage] = useState("");

  const [userlist, setuserlist] = useState([
    {
      value: "salesUser",
      label: "SalesUsers",
    },
    {
      value: "user",
      label: "Adverisers",
    },
    {
      value: "dsa",
      label: "Trade Partners (All)",
    },
    {
      value: "dsa_active",
      label: "Trade Partners (Active)",
    },
    {
      value: "dsa_inactive",
      label: "Trade Partners (Inactive)",
    },
    {
      value: "dsa_rejected",
      label: "Trade Partners (Rejected)",
    },
    {
      value: "financeAdmin",
      label: "Finance Admins",
    },
    {
      value: "campaignAdmin",
      label: "CampaignAdmins",
    },
    {
      value: "audioAdmin",
      label: "Audio Admin",
    },
    {
      value: "stationAdmin",
      label: "Station Admin",
    },
    {
      value: "trafficAdmin",
      label: "Traffic Admin",
    },
    {
      value: "clusterAdmin",
      label: "Cluster Admin",
    },
  ]);

  const adminData = JSON.parse(localStorage.getItem("adminInfo"));

  const handleUploadedAudioBrief = (e) => {
    setAudioBrief(e);
  };

  const styles = {
    editor: {
      border: "1px solid gray",
      height: "16em",
      backgroundColor: "white",
      overflow:"auto"
    },
  };
  const setEditorState = (editor) => {
    setEditor(editor);
  };
  const focusEditor = () => {
    if (editor) {
      editor.focus();
    }
  };

  const SendNotification = async () => {
    if (selectedUsers.length == 0) {
      toast.error(`Recipents are empty`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (sentby === "email" && !subject) {
      toast.error(`Subject is mandatory for email`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (sentby === "email" && !audioBrief.getCurrentContent().hasText()) {
      toast.error(`Mail body is mandatory for email`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (sentby === "sms" && !message) {
      toast.error(`Message is mandatory for sms`, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    let convertedHTML = draftToHtml(
      convertToRaw(audioBrief.getCurrentContent())
    );
    let data = {
      type: sentby,
      subject: subject,
      message: sentby === "email" ? convertedHTML : message,
      usernamelist: selectedUsers.map((e) => e.label),
      users: selectedUsers.map((e) => e.value),
      sentby: adminData.email,
    };
    let status = await Axios.post(endPoints.broadcast, data);
    debugger
    if (status.data.code === 200) {
      let message =
        sentby === "email"
          ? "Mail Sent Successfully"
          : "Message Sent Successfully";
      toast.success(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      setselectedUsers([]);
      setsubject("");
      setmessage("");
      setAudioBrief(EditorState.createEmpty());
    } else if (status.data.code === 404) {
      toast.error(status.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
    }
  };

  return (
    <div className="dashboardContainer">
      <HeaderAdminpanel />
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>

        <section
          id="dashboard-rightContainer"
          className="dashboard-manageSales"
        >
          <div className="container-head">
            <div className="dashboard-breadcrumb">Notification Management</div>
          </div>
          <div className="create_coupon">
            <h3>Broadcast Message</h3>
            <div className="coupon_type">
              <div style={{ display: "inline-block" }}>
                <span className="coupon_head">Send By</span>
                <div className="radio_coupon">
                  <p className="percentage_container">
                    <input
                      type="radio"
                      id="coupon1"
                      name="radio_coupon"
                      checked={sentby === "email"}
                      className="custm_radio"
                      onClick={() => {
                        setsentby("email");
                      }}
                    />
                    <label for="coupon1">Email</label>
                  </p>
                  <p>
                    <input
                      type="radio"
                      id="coupon2"
                      name="radio_coupon"
                      className="custm_radio"
                      checked={sentby === "sms"}
                      onClick={() => {
                        setsentby("sms");
                      }}
                    />
                    <label for="coupon2">SMS</label>
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: "inline-block",
                  marginLeft: "100px",
                  width: "70%",
                }}
              >
                <label>To</label>
                <Select
                  isMulti
                  options={userlist}
                  value={selectedUsers}
                  onChange={(event, newValue) => {
                    debugger;
                    setselectedUsers(event);
                  }}
                />
              </div>
            </div>
            {sentby === "email" && (
              <React.Fragment>
                <div style={{ marginBottom: "3%" }}>
                  <p>
                    <label for="subject" style={{ marginRight: "3%" }}>
                      Subject
                    </label>
                    <input
                      id="subject"
                      style={{ width: "85%", height: "5vh" }}
                      placeholder="Enter the subject"
                      value={subject}
                      onChange={(e) => {
                        setsubject(e.target.value);
                      }}
                    />
                  </p>
                </div>
                <div className="audio_brief">
                  <div className="toolbar">
                    <ToolbarStatic>
                      {// may be use React.Fragment instead of div to improve perfomance after React 16
                      (externalProps) => (
                        <React.Fragment>
                          <BoldButton {...externalProps} />
                          <ItalicButton {...externalProps} />
                          <UnderlineButton {...externalProps} />
                          <CodeButton {...externalProps} />
                          <HeadlinesButton {...externalProps} />
                          <UnorderedListButton {...externalProps} />
                          <OrderedListButton {...externalProps} />
                          <BlockquoteButton {...externalProps} />
                        </React.Fragment>
                      )}
                    </ToolbarStatic>
                  </div>
                  <div onClick={focusEditor} style={styles.editor}>
                    <Editor
                      ref={setEditorState}
                      placeholder="Enter Message"
                      editorState={audioBrief}
                      onChange={handleUploadedAudioBrief}
                      plugins={[staticToolBarPlugin]}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
            {sentby === "sms" && (
              <React.Fragment>
                <div style={{ marginBottom: "3%", height: "30vh" }}>
                  <p>
                    <label for="msg" style={{ marginRight: "3%" }}>
                      Message
                    </label>
                    <textarea
                      id="message"
                      style={{ width: "85%", height: "30vh" }}
                      placeholder="Enter the Message"
                      value={message}
                      onChange={(e) => {
                        setmessage(e.target.value);
                      }}
                    />
                  </p>
                </div>
              </React.Fragment>
            )}
            <div className="generate_coupon">
              <button onClick={SendNotification}>Send</button>
            </div>
          </div>
        </section>
      </div>

      {/* <Index/> */}
      <ToastContainer />
      {/* {contact.length ===0 ?
              <NoData /> : null} */}
    </div>
  );
};

export default connect(null, {})(Notification);



// WEBPACK FOOTER //
// ./web/components/admin/manageNotification/index.js